<div class="input-group flex-nowrap h-100" [class.input-group-sm]="small">
  <span class="input-group-text" [ngClass]="disabled ? 'text-gray-300' : 'bg-white-100'" id="basic-addon" [style.min-width]="width" (click)="!disabled ? fromTo.toggle() : false">
    {{fromDate | date: format}} - {{toDate | date: format}}
  </span>
  <ngbd-datepicker-range #fromTo
                         [fromDate]="fromDate" [autoClose]="autoClose"
                         [toDate]="toDate"
                         [showTime]="showTime" [class]="class"
                         [showSeconds]="showSeconds"
                         [initOpened]="initOpened"
                         (dateSelect)="dateSelect.emit($event); ($event.From && $event.To) ? fromTo.picker.close() : true"></ngbd-datepicker-range>
  <button class="btn btn-outline-default ms-0" *ngIf="hasButton" (click)="fromTo.toggle()" [disabled]="disabled">
    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#calendar-days">
    </svg>
  </button>
</div>
